import { render } from "./CreditScoringRule.vue?vue&type=template&id=96091efa&scoped=true"
import script from "./CreditScoringRule.vue?vue&type=script&lang=js"
export * from "./CreditScoringRule.vue?vue&type=script&lang=js"

import "./CreditScoringRule.vue?vue&type=style&index=0&id=96091efa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/admin-ui-svc/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96091efa"]])

export default __exports__